import "./App.css";
import React, { useState } from "react";
import copyIcon from "./res/copy.svg";
import ITEMS from "./items";
import profile from "./res/profile.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

// https://shreevinayakartsbackend.onrender.com
function Home() {
  const [cartItems, setCartItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const EcoItems = ITEMS[0];
  const PopItems = ITEMS[1];
  const [cartTotal, setCartTotal] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [login, setLogin] = useState(true);
  const [name, setName] = useState("");
  const [regPass, setRegPass] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginUserName, setLoginUserName] = useState("");

  const generateKey = (pre) => {
    return `${pre}_${new Date().getTime()}`;
  };

  function copyTxt() {
    var txt = document.getElementsByClassName("tooltiptext");
    txt[0].style.display = "inline";

    var textArea = document.createElement("textarea");
    textArea.value = "+91 9768624276";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();
  }

  function close(e) {
    let list = document.body.classList;
    if (list.contains("about-on")) {
      list.remove("about-on");
    } else if (list.contains("contact-on")) {
      list.remove("contact-on");
    } else if (list.contains("eco-on")) {
      list.remove("eco-on");
    } else if (list.contains("pop-on")) {
      list.remove("pop-on");
    } else {
      list.remove("cart-on");
    }
  }

  function fetchCartItems() {
    let items = JSON.parse(window.localStorage.getItem("cartItems"));
    let total = window.localStorage.getItem("cartTotal");
    if (items) {
      setCartItems(items);
      setCartTotal(total);
    }
    document.body.classList.add("cart-on");
  }

  function addItemToCart(item) {
    let currentItem = cartItems.filter((i) => i.id === item.id);
    if (currentItem.length) {
      notify("Item already exists in cart", "error");
      return;
    }

    const updatedCartItems = [...cartItems, item];
    setCartItems(updatedCartItems);
    setCartTotal(cartTotal + item.price);

    window.localStorage.setItem(
      "cartItems",
      JSON.stringify([...cartItems, item])
    );
    window.localStorage.setItem("cartTotal", Number(cartTotal) + item.price);

    notify("Item Added to Cart 🛒", "success");
  }

  function removeItemFromCart(item) {
    setCartTotal(cartTotal - item.price * item.quantity);
    const updatedCart = cartItems.filter((i) => i.id !== item.id);
    setCartItems(updatedCart);
    window.localStorage.setItem(
      "cartTotal",
      Number(
        window.localStorage.getItem("cartTotal") - item.price * item.quantity
      )
    );
    window.localStorage.setItem("cartItems", JSON.stringify(updatedCart));
    notify("Item Removed from cart", "error");
  }

  function quantityIncrease(item) {
    cartItems.forEach((i) => {
      if (i.id === item.id) {
        i.quantity += 1;
      }
    });

    let currentItems = JSON.parse(window.localStorage.getItem("cartItems"));
    currentItems.forEach((i) => {
      if (i.id === item.id) {
        i.quantity += 1;
      }
    });

    setCartTotal(Number(cartTotal) + item.price);
    window.localStorage.setItem("cartItems", JSON.stringify(currentItems));
    window.localStorage.setItem("cartTotal", Number(cartTotal) + item.price);
  }

  function quantityDecrease(item) {
    if (cartItems[0].quantity === 1) {
      return;
    }
    cartItems.forEach((i) => {
      if (i.id === item.id) {
        i.quantity -= 1;
      }
    });
    let currentItems = JSON.parse(window.localStorage.getItem("cartItems"));
    currentItems.forEach((i) => {
      if (i.id === item.id) {
        i.quantity -= 1;
      }
    });

    setCartTotal(cartTotal - item.price);
    window.localStorage.setItem("cartItems", JSON.stringify(currentItems));
    window.localStorage.setItem("cartTotal", Number(cartTotal) - item.price);
  }

  function purchaseClicked() {
    if (cartItems.length < 1) {
      alert("No Items");
      return;
    }
    checkLoggedIn(false);
  }

  function buy() {
    fetch("https://shreevinayakartsbackend.onrender.com/purchase", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: cartItems,
        token: localStorage.getItem("token"),
      }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        return res.json().then((json) => Promise.reject(json));
      })
      .then(({ url }) => {
        window.location = url;
      })
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function openProfile() {
    checkLoggedIn(true);
  }

  function checkLoggedIn(onlyCheck) {
    const token = localStorage.getItem("token");
    if (token) {
      fetch("https://shreevinayakartsbackend.onrender.com/check-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: token,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.isTrue) {
            if (onlyCheck) {
              document.body.classList.toggle("profile-on");
            } else {
              buy();
            }
          } else {
            setIsOpen(true);
          }
        })
        .catch((error) => {
          console.error("Error occurred while checking login status:", error);
        });
    } else {
      setIsLoggedIn(false);
      setIsOpen(true);
    }
  }

  function performLogin() {
    fetch("https://shreevinayakartsbackend.onrender.com/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: loginUserName, password: loginPass }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.token) {
          notify(data.message, "success");
          localStorage.setItem("token", data.token);
          setIsLoggedIn(true);
          setIsOpen(false);
          document.body.classList.toggle("profile-on");
        } else {
          notify(data.message, "error");
        }
      })
      .catch((error) => {
        notify("Error Occurred", "error");
      });
  }

  function performRegistration() {
    fetch("https://shreevinayakartsbackend.onrender.com/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: name,
        username: regEmail,
        password: regPass,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        notify(data.message, "success");
      })
      .catch((error) => {
        notify("Error Occured", "error");
      });
  }

  function performLogout() {
    window.localStorage.removeItem("token");
    document.body.classList.remove("profile-on");
    notify("Logged out successfully", "success");
  }

  function ordersClicked() {
    document.body.classList.toggle("profile-on");
    document.body.classList.add("orders-on");

    fetch("https://shreevinayakartsbackend.onrender.com/getOrders", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: localStorage.getItem("token") }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        return res.json().then((json) => Promise.reject(json));
      })
      .then(({ purchases }) => {
        setOrders(purchases);
        let temp = [];
        purchases.forEach((order) => {
          temp.push(order.orderItems);
        });
        let temp2 = [];
        temp.forEach((b) => {
          temp2.push(JSON.parse(b));
        });
        setOrderItems(temp2);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function notify(msg, type) {
    if (type === "success") {
      toast.success(msg, {
        position: "top-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      toast.error(msg, {
        position: "top-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }

  return (
    <div>
      <div className="hero-section">
        <div
          className="about-text hover-target"
          onClick={() => document.body.classList.add("about-on")}
        >
          about
        </div>
        <div
          className="contact-text hover-target"
          onClick={() => document.body.classList.add("contact-on")}
        >
          contact
        </div>
        <div className="cart hover-target" onClick={fetchCartItems}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M289.788-69Q260-69 239-90.212q-21-21.213-21-51Q218-171 239.212-192q21.213-21 51-21Q320-213 341-191.788q21 21.213 21 51Q362-111 340.788-90q-21.213 21-51 21Zm404 0Q664-69 643-90.212q-21-21.213-21-51Q622-171 643.212-192q21.213-21 51-21Q724-213 745-191.788q21 21.213 21 51Q766-111 744.788-90q-21.213 21-51 21ZM452-627q-12-13.267-12-29.633Q440-673 452-685l46-46H362q-17.75 0-29.875-11.488T320-771.684q0-17.709 12.125-29.512Q344.25-813 362-813h136l-45-46q-12-11-12.544-28.071-.544-17.072 11.404-29.392 11.947-12.626 29.044-12.082Q498-928 510-916l112 111q6.818 7.6 10.409 16.138Q636-780.324 636-771.367q0 8.958-3.591 17.362Q628.818-745.6 622-739L510-627q-12 12-29 12t-29-12ZM290-276q-46.989 0-70.995-39.5Q195-355 219-396l58-105-144-308H92q-17.425 0-29.212-11.777Q51-832.555 51-849.965q0-17.41 11.788-29.223Q74.575-891 92-891h63q14 0 26.3 6.826T198-865l152 326h289l138-247q4.684-9.75 14.976-15.375Q802.267-807 813.399-807q23.274 0 34.937 20Q860-767 849-746L711-497q-10.695 18.714-28.319 29.857T640-456H347l-55 98h444q17.425 0 29.213 11.777Q777-334.445 777-317.035q0 17.41-11.787 29.223Q753.425-276 736-276H290Z" />
          </svg>
        </div>
        <div className="profile hover-target" onClick={openProfile}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M224.261-261.218q62.435-42.869 123.869-65.804 61.435-22.935 132.116-22.935 70.68 0 132.889 23.369 62.208 23.369 123.604 65.37 42.87-54.565 60.522-106.997T814.913-480q0-142.313-96.271-238.613-96.271-96.3-238.543-96.3-142.273 0-238.642 96.3-96.37 96.3-96.37 238.613 0 59.304 17.885 111.601 17.885 52.296 61.289 107.181Zm255.553-184.825q-59.599 0-99.902-40.534-40.303-40.534-40.303-99.761t40.489-99.858q40.489-40.63 100.088-40.63t99.902 40.816q40.303 40.817 40.303 100.044t-40.489 99.575q-40.489 40.348-100.088 40.348Zm.324 380.174q-84.964 0-160.445-32.512-75.48-32.513-132.132-89.152-56.652-56.64-89.172-131.916-32.52-75.276-32.52-160.864 0-84.948 32.63-160.274 32.631-75.326 89.109-131.805 56.479-56.478 131.782-89.391 75.304-32.913 160.923-32.913 84.948 0 160.274 32.913 75.326 32.913 131.805 89.391 56.478 56.479 89.391 131.884 32.913 75.405 32.913 160.37 0 84.964-32.913 160.508-32.913 75.543-89.391 132.022-56.479 56.478-131.884 89.109-75.405 32.63-160.37 32.63ZM480-145.087q53.304 0 102.978-14.87 49.674-14.869 100.674-53.173-51.565-35.435-101.174-53.022Q532.87-283.739 480-283.739t-102.195 17.587q-49.326 17.587-100.892 53.022 51 38.304 100.392 53.173 49.391 14.87 102.695 14.87Zm0-367.739q32.229 0 52.919-20.37 20.69-20.369 20.69-52.956t-20.69-53.239q-20.69-20.652-52.919-20.652t-52.919 20.652q-20.69 20.652-20.69 53.239 0 32.587 20.69 52.956 20.69 20.37 52.919 20.37Zm0-73.609Zm.565 372.305Z" />
          </svg>
        </div>
        <div className="section-center">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <h1 className="">
                  गणपती बाप्पा
                  <br />
                  मोरया
                </h1>
              </div>
              <div className="col-12 text-center mb-2">
                <div className="dancing">
                  <span> श्री विनायक आर्ट्स </span>
                </div>
              </div>
              <div className="col-12 text-center">
                <p>
                  <span
                    className="eco hover-target"
                    onClick={() => document.body.classList.add("eco-on")}
                  >
                    Eco-Friendly
                  </span>
                  <span
                    className="pop hover-target"
                    onClick={() => document.body.classList.add("pop-on")}
                  >
                    Plaster of Paris ( PoP )
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section">
        <div className="close hover-target" onClick={(e) => close(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <img src={profile} alt="" />
              </div>
              <div className="col-lg-8 text-center mt-3">
                <p className="mb-1">
                  आमच्या येथे श्री च्या व दुर्गामातेच्या सुंदर व सुबक आकर्षक
                  मूर्ती रंगकाम करून मुर्त्या स्वस्त दारात बनवून मिळतील.
                  <br />
                  शाडू मातीच्या इकोफ्रेंडली मूर्ती बनवून मिळतील.
                </p>
              </div>
              <div className="col-12 text-center">
                <p className="mb-0">
                  <span>श्री विनायक आर्ट्स</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-section ">
        <div className="close hover-target" onClick={(e) => close(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <a
                  // href="https://mail.google.com/mail/?view=cm&fs=1&to=shrivinayakarts@gmail.com&authuser=0"
                  href="mailto:shrivinayakarts@gmail.com"
                  className="hover-target"
                >
                  shrivinayakarts@gmail.com
                </a>
              </div>
              <div className="col-12 text-center social mt-4">
                <a
                  href="https://www.facebook.com/shreevinayakarts/"
                  className="hover-target"
                >
                  facebook
                </a>
                <a href="tel:9768624276" className="hover-target">
                  +91 9768624276{" "}
                </a>
                <img
                  src={copyIcon}
                  alt="Copy Icon"
                  className="copy-icon"
                  onClick={copyTxt}
                />
                <span className="tooltiptext">Copied to Clipboard</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="eco-section">
        <div className="close hover-target" onClick={(e) => close(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h3>Eco-Friendly</h3>
            </div>
            <div className="shop-items">
              {EcoItems.map((item) => {
                return (
                  <div className="shop-item col-md-6 col-lg-4" key={item.id}>
                    <span className="shop-item-title">{item.title}</span>
                    <img
                      className="shop-item-image"
                      src={item.imgSrc}
                      alt={item.title}
                      loading="lazy"
                    />
                    <div className="shop-item-details">
                      <span className="shop-item-price">₹{item.price}</span>
                      <button
                        className="btn btn-primary shop-item-button"
                        type="button"
                        onClick={() => addItemToCart(item)}
                      >
                        ADD TO CART
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="pop-section">
        <div className="close hover-target" onClick={(e) => close(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h3>Plaster of Paris (PoP)</h3>
            </div>
            <div className="col-12 text-center"></div>
            <div className="shop-items">
              {PopItems.map((item) => {
                return (
                  <div className="shop-item col-md-6 col-lg-4" key={item.id}>
                    <span className="shop-item-title">{item.title}</span>
                    <img
                      className="shop-item-image"
                      src={item.imgSrc}
                      alt={item.title}
                      loading="lazy"
                    />
                    <div className="shop-item-details">
                      <span className="shop-item-price">₹{item.price}</span>
                      <button
                        className="btn btn-primary shop-item-button"
                        type="button"
                        onClick={() => addItemToCart(item)}
                      >
                        ADD TO CART
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="cart-section">
        <div className="close hover-target" onClick={(e) => close(e)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="section-center">
          <h2 className="section-header">CART</h2>
          <div className="cart-row">
            <span className="cart-item cart-header cart-column">ITEM</span>
            <span className="cart-price cart-header cart-column">PRICE</span>
            <span className="cart-header cart-column">QUANTITY</span>
          </div>

          <div className="cart-items">
            {cartItems &&
              cartItems.map((item) => {
                return (
                  <div className="cart-row" key={generateKey(item.id)}>
                    <div className="cart-item cart-column">
                      <img
                        className="cart-item-image"
                        src={item.imgSrc}
                        width="100"
                        height="100"
                        alt=""
                      />
                      <span className="cart-item-title">{item.title}</span>
                    </div>
                    <span className="cart-price cart-column">{item.price}</span>
                    <div className="cart-quantity-container cart-column">
                      <div className="cart-quantity">
                        <button
                          className="cart-quantity-input"
                          onClick={() => quantityDecrease(item)}
                        >
                          -
                        </button>
                        <div
                          className="cart-quantity-input "
                          style={{ userSelect: "none" }}
                        >
                          {item.quantity}
                        </div>
                        <button
                          className="cart-quantity-input "
                          onClick={() => quantityIncrease(item)}
                        >
                          +
                        </button>
                      </div>
                      <div className="cart-remove">
                        <button
                          className="btn btn-danger"
                          onClick={() => removeItemFromCart(item)}
                          type="button"
                        >
                          REMOVE
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            <div className="cart-total">
              <strong className="cart-total-title">Total</strong>
              <span className="cart-total-price">₹{cartTotal}</span>
            </div>
          </div>

          <button
            className="btn btn-primary btn-purchase"
            onClick={purchaseClicked}
          >
            PURCHASE
          </button>
        </div>
      </div>
      <div className="profile-section">
        <div>
          <h2 className="section-header">PROFILE</h2>
          <div className="profile-nav">
            <span onClick={ordersClicked}>My Orders</span>
            <span onClick={performLogout}>Logout</span>
          </div>
        </div>
      </div>
      <div className="orders-section">
        <div
          className="close hover-target"
          onClick={() => document.body.classList.remove("orders-on")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
          >
            <path d="M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" />
          </svg>
        </div>
        <div className="section">
          <div className="order-header">ORDERS</div>
          <div className="card-container">
            {orderItems &&
              orderItems.map((order, index) => {
                return (
                  <div className="card" key={"order" + String(index)}>
                    <div className="order">Order Summary</div>
                    {order.map((subOrder) => {
                      return (
                        <div className="Order-summary">
                          <img
                            className="cart-item-image"
                            src={subOrder.imgSrc}
                            width="100"
                            height="100"
                            alt=""
                          />
                          <div className="order-items">
                            <div>Item Name : {subOrder.title}</div>
                            <div>Quantity : {subOrder.quantity}</div>
                            <div>Price (per piece) : {subOrder.price}</div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="order-details">
                      <div className="order-total">
                        Total : {orders[index].amount}
                      </div>
                      <div className="order-date">
                        Date : {orders[index].date}
                      </div>
                      <div className="order-receipt">
                        <a
                          href={`${orders[index].receipt}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Download Receipt
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      {!isLoggedIn && (
        <dialog
          onClose={() => setIsOpen(false)}
          className="modal__container"
          open={isOpen}
        >
          <button className="btn_back" onClick={() => setIsOpen(false)}>
            Go Back
          </button>
          <div className="login-page">
            <div className="form">
              {login === true ? (
                <div className="login-form">
                  <input
                    type="text"
                    placeholder="username"
                    autoComplete="username"
                    value={loginUserName}
                    onChange={(e) => setLoginUserName(e.target.value)}
                  />
                  <input
                    type="password"
                    placeholder="password"
                    autoComplete="current-password"
                    value={loginPass}
                    onChange={(e) => setLoginPass(e.target.value)}
                  />
                  <button onClick={performLogin}>login</button>
                  <p className="message">
                    Not registered?{" "}
                    <span
                      onClick={() => {
                        setLogin(false);
                      }}
                    >
                      Create an account
                    </span>
                  </p>
                </div>
              ) : (
                <div className="register-form">
                  <input
                    type="text"
                    placeholder="name"
                    autoComplete="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="email address"
                    value={regEmail}
                    onChange={(e) => setRegEmail(e.target.value)}
                  />
                  <input
                    type="password"
                    placeholder="password"
                    autoComplete="current-password"
                    value={regPass}
                    onChange={(e) => setRegPass(e.target.value)}
                  />
                  <button onClick={performRegistration}>create</button>
                  <p className="message">
                    Already registered?{" "}
                    <span
                      onClick={() => {
                        setLogin(true);
                      }}
                    >
                      Sign In
                    </span>
                  </p>
                </div>
              )}
            </div>
          </div>
        </dialog>
      )}
      <ToastContainer />
    </div>
  );
}

export default Home;
